import React from 'react';
import logo from '../../assets/logo.svg';
import logoType from '../../assets/logotype.svg';
import { Box, BoxProps, Image } from 'rebass';

type LogoProps = BoxProps & {
  /**
   * Show logotype?
   */
  showLogotype?: boolean;
};

const Logo = (props: LogoProps): JSX.Element => (
  <Box
    display="inline-flex"
    height="scale.9"
    maxWidth="100%"
    width="auto"
    padding="4"
    {...(props as any)}
  >
    <Image
      src={props.showLogotype ? logoType : logo}
      alt="Ecosconnect Logo"
      sx={{
        cursor: 'pointer',
        width: 'auto',
        height: '100%',
      }}
    />
  </Box>
);

export default Logo;
